export default class StoreDataInteractionInputDTO {
  totalAmountWithoutAddServices

  static factoryMySelf() {
    return new StoreDataInteractionInputDTO()
  }
}
